export default __webpack_public_path__ + "static/media/jinja.cca3401d.png";